import { useEffect, useState } from 'react'
import { filterUserActivitiesByType } from 'services'
import { Modal, Pagination } from 'stories/components'
import { formatTime } from 'utils'

const itemCountPerPage = 10

export const SubscribeLogModal = ({ onClose }: { onClose: Function }) => {
  const [loading, setLoading] = useState(false)
  const [pageNum, setPageNum] = useState(0)
  const [activities, setActivities] = useState<Array<Record<string, any>>>([])
  const [total, setTotal] = useState(0)

  useEffect(() => {
    initData()
  }, [])

  const initData = async () => {
    setLoading(true)
    const { data, total } = await filterUserActivitiesByType({
      count: itemCountPerPage,
      skip: 0,
      type: 'subscribe_email',
    })
    setActivities(data)
    setTotal(total)
    setPageNum(0)
    setLoading(false)
  }

  const onPageNavigate = async (num: number) => {
    setPageNum(num)

    setLoading(true)
    const { data, total } = await filterUserActivitiesByType({
      count: itemCountPerPage,
      skip: num * itemCountPerPage,
      type: 'subscribe_email',
    })
    setActivities(data)
    setTotal(total)
    setLoading(false)
  }

  return (
    <Modal title="Subscribe Log" titleOkay="" loading={loading} isOpen onClose={() => onClose()}>
      <>
        <table className="w-full text-sm text-left text-gray-900 dark:text-gray-400 pl-6">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="pl-6 py-3">
                No
              </th>
              <th scope="col" className="px-3">
                Company Name
              </th>
              <th scope="col" className="px-3">
                Name
              </th>
              <th scope="col" className="px-3">
                Email
              </th>
              <th scope="col" className="px-3">
                Date
              </th>
              <th scope="col" className="px-3">
                Subscribe
              </th>
            </tr>
          </thead>
          <tbody className="">
            {activities.map((activity, index) => {
              return (
                <tr
                  className="bg-white hover:bg-gray-100 border-b dark:bg-gray-800 dark:border-gray-700"
                  key={`${pageNum * itemCountPerPage + index}`}
                >
                  <th scope="row" className="pl-6 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {pageNum * itemCountPerPage + index + 1}
                  </th>
                  <td className="px-3">{activity.companyName}</td>
                  <td className="px-3">{activity.name}</td>
                  <td className="px-3">{activity.email}</td>
                  <td className="px-3">{formatTime(activity.createdAt)}</td>
                  <td className="px-3">{activity.detail.subscribeBroadcastEmail ? 'Yes' : 'No'}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <div className="flex justify-end items-center mt-3 mb-3">
          <Pagination
            totalCount={total}
            itemCountPerPage={itemCountPerPage}
            onNavigate={onPageNavigate}
            pageNum={pageNum}
          />
        </div>
      </>
    </Modal>
  )
}
